import { render, staticRenderFns } from "./settings-date-format.vue?vue&type=template&id=616fe778"
import script from "./settings-date-format.vue?vue&type=script&lang=js"
export * from "./settings-date-format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports